import React from "react";
import { Paper } from "@mui/material";
import { Button } from "@mui/material";
import FormDialog from "../panel/modal";
import AddCareerForm from "../form/addCareerForm";
import { useNavigate } from "react-router-dom";
import ViewCareer from "../table/viewCareer";

const CareerAdmin = () => {
  const navigation = useNavigate();

  const [open, setOpen] = React.useState(false);
  const [modalData, setModalData] = React.useState();

  const handleClickOpen = (data) => {
    setOpen(true);
    setModalData(data);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="row">
        <Paper elevation={3}>
          <div className="col-12 p-2"></div>

          <div className="col-12 d-flex justify-content-between p-2">
            <div></div>
            <Button variant="contained" onClick={handleClickOpen}>
              +Add Carrer Ad
            </Button>
          </div>

          <FormDialog
            form={
              <AddCareerForm
                handleClose={handleClose}
                handleClickOpen={handleClickOpen}
                modalData={modalData}
              />
            }
            title="Add Career"
            open={open}
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
          />
        </Paper>

        <Paper>
          <div className="col-12">
            <ViewCareer handleClickOpen={handleClickOpen} />
          </div>
        </Paper>
      </div>
    </>
  );
};

export default CareerAdmin;
